import React from 'react';

import Button from '@atlaskit/button';

export default function ContactSupport(): JSX.Element {
  return (
    <Button onClick={() => window.open(plugin.feedbackUrl, '_blank')}>
      Contact support
    </Button>
  );
}
